import { render, staticRenderFns } from "./components-tab.vue?vue&type=template&id=082cb3f2&scoped=true"
import script from "./components-tab.ts?vue&type=script&lang=js&external"
export * from "./components-tab.ts?vue&type=script&lang=js&external"
import style0 from "./components-tab.less?vue&type=style&index=0&id=082cb3f2&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082cb3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082cb3f2')) {
      api.createRecord('082cb3f2', component.options)
    } else {
      api.reload('082cb3f2', component.options)
    }
    module.hot.accept("./components-tab.vue?vue&type=template&id=082cb3f2&scoped=true", function () {
      api.rerender('082cb3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/components-tab/components-tab.vue"
export default component.exports